const disableDoubleTouch = () => {
  // test for disable double touch on mobile
  let lastTouchEnd = 0;
  document.addEventListener(
    'touchend',
    (event) => {
      const now = new Date();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false,
  );
};

// noinspection JSUnusedGlobalSymbols
export default disableDoubleTouch;
